// Code review - Completed
// Documentation - Completed
import React, { useEffect, useRef, useState } from "react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import StayCool from "../image/StayCool.png";
import MainPopup from "../popup-containers/MainPopup";
import UserProfile from "../popup-containers/UserProfile";
import { useUserCapability } from "./ConstantReducerProvider";
import PasswordPopup from "../popup-containers/PasswordPopup";
import SystemSettingsPopup from "../popup-containers/SystemSettingsPopup";
import { IUDAPI, LoginAPI } from "../services/APIConnection";

function TopMenu() {
  const navigate = useNavigate();
  const loction = useLocation();
  const [currentMenuId, setCurrentMenuId] = useState(null);
  const { userProfileState, dispatch } = useUserCapability();
  const [showLogoutModal, setShowLogoutModal] = useState(false);

  const userProfileDatas = userProfileState.userProfile;

  const userCapabilityTopMenu = userProfileState.userVsCapability;
  const userProfileImg =
    userProfileDatas && userProfileDatas.length > 0
      ? userProfileDatas[0].UserProfileImg
      : null;
  const userName =
    userProfileDatas && userProfileDatas.length > 0
      ? userProfileDatas[0].UserName
      : null;
  const firstName =
    userProfileDatas && userProfileDatas.length > 0
      ? userProfileDatas[0].FirstName
      : null;
  const roleName =
    userProfileDatas && userProfileDatas.length > 0
      ? userProfileDatas[0].RoleName
      : null;

  const OrganizationName =
    userProfileDatas && userProfileDatas.length > 0
      ? userProfileDatas[0].Organization
      : null;

  const paymentStatus = sessionStorage.getItem("paymentStatus");
  const roleId = sessionStorage.getItem("roleId");
  useEffect(() => {
    var createdBy = sessionStorage.getItem("createdBy");

    if (createdBy == null || createdBy == "") {
      navigate("/");
    }
  }, []);
  const userVsCapability = userProfileState.userVsCapability;

  useEffect(() => {
    if (loction) {
      const menuId1 = loction.state?.menuId;
      const MenuId = userCapabilityTopMenu
        .filter((x) => x.MenuPath == loction.pathname)
        .map((item) => item.MstMenuId)
        .toString();
      const getMstMainMenuHeadingId = userCapabilityTopMenu
        .filter((x) => x.MenuPath == loction.pathname)
        .map((item) => item.MstMenuHeadingId)
        .toString();

      if (
        getMstMainMenuHeadingId == 1 ||
        getMstMainMenuHeadingId == 2 ||
        getMstMainMenuHeadingId == 3 ||
        getMstMainMenuHeadingId == 4 ||
        getMstMainMenuHeadingId == 5
      ) {
        setCurrentMenuId(getMstMainMenuHeadingId); // Set current menu ID based on the retrieved ID
      }
    }
  }, [loction, userProfileState]);
  // Helper function to check if a specific path exists in backend data
  const hasMenuPath = (path) => {
    return userCapabilityTopMenu.some((item) => item.MenuPath === path);
  };
  if (userCapabilityTopMenu.filter((item) => item.MstMenuHeadingId === 1)) {
    var dynamnicTopMenu = userCapabilityTopMenu
      .filter((item) => item.MstMenuHeadingId === 1)
      .map((item) => ({
        title: item.MenuHeading,
        menuHeadingId: item.MstMenuHeadingId,
        menuPath: item.MenuPath,
      }));

    var dynamnicTopMenuMobile = userCapabilityTopMenu
      .filter((item) => item.MstMenuHeadingId === 1)
      .map((item) => ({
        title: item.MenuHeading,
        menuHeadingId: item.MstMenuHeadingId,
        menuPath: item.MenuPath,
        icon: (
          <svg viewBox="0 0 24 24" fill="currentColor" class="w-6 h-6">
            <path d="M21 16V4H3v12h18m0-14a2 2 0 012 2v12a2 2 0 01-2 2h-7v2h2v2H8v-2h2v-2H3a2 2 0 01-2-2V4c0-1.11.89-2 2-2h18M5 6h9v5H5V6m10 0h4v2h-4V6m4 3v5h-4V9h4M5 12h4v2H5v-2m5 0h4v2h-4v-2z" />
          </svg>
        ),
      }));
  } else {
    console.log("LandingPage permission denied");
  }

  if (userCapabilityTopMenu.filter((item) => item.MstMenuHeadingId === 2)) {
    var dynamnicTopMenu2 = userCapabilityTopMenu
      .filter((item) => item.MstMenuHeadingId === 2)
      .map((item) => ({
        title: item.MenuHeading,
        menuHeadingId: item.MstMenuHeadingId,
        menuPath: item.MenuPath,
        mstMenuId: item.MstMenuId,
      }));
  } else {
    console.log("Administrator permission denied");
  }

  if (dynamnicTopMenu2.length > 0) {
    var TopMenuAdmin = {
      title: dynamnicTopMenu2[0].title,
      menuHeadingId: dynamnicTopMenu2[0].menuHeadingId,
      menuPath: dynamnicTopMenu2[0].menuPath,
      menuId: dynamnicTopMenu2[0].mstMenuId,
    };

    var TopMenuAdminMobile = {
      title: dynamnicTopMenu2[0].title,
      menuHeadingId: dynamnicTopMenu2[0].menuHeadingId,
      menuPath: dynamnicTopMenu2[0].menuPath,
      menuId: dynamnicTopMenu2[0].mstMenuId,
      icon: (
        <svg viewBox="0 0 24 24" fill="currentColor" class="w-6 h-6">
          <path fill="none" d="M0 0h24v24H0z" />
          <path d="M12 14v8H4a8 8 0 018-8zm0-1c-3.315 0-6-2.685-6-6s2.685-6 6-6 6 2.685 6 6-2.685 6-6 6zm2.595 5.812a3.51 3.51 0 010-1.623l-.992-.573 1-1.732.992.573A3.496 3.496 0 0117 14.645V13.5h2v1.145c.532.158 1.012.44 1.405.812l.992-.573 1 1.732-.992.573a3.51 3.51 0 010 1.622l.992.573-1 1.732-.992-.573a3.496 3.496 0 01-1.405.812V22.5h-2v-1.145a3.496 3.496 0 01-1.405-.812l-.992.573-1-1.732.992-.572zM18 17a1 1 0 100 2 1 1 0 000-2z" />
        </svg>
      ),
    };
  }

  if (userCapabilityTopMenu.filter((item) => item.MstMenuHeadingId === 3)) {
    var dynamnicTopMenu3 = userCapabilityTopMenu
      .filter((item) => item.MstMenuHeadingId === 3)
      .map((item) => ({
        title: item.MenuHeading,
        menuHeadingId: item.MstMenuHeadingId,
        menuPath: item.MenuPath,
        mstMenuId: item.MstMenuId,
        relatedMenu: item.RelatedMenu ? item.RelatedMenu : null,
      }));
  } else {
    console.log("Transaction permission denied");
  }

  if (dynamnicTopMenu3.length > 0) {
    var TopMenuTransaction = {
      title: dynamnicTopMenu3[0].title,
      menuHeadingId: dynamnicTopMenu3[0].menuHeadingId,
      menuPath: dynamnicTopMenu3[0].menuPath,
      menuId: dynamnicTopMenu3[0].mstMenuId,
      relatedMenu: dynamnicTopMenu3[0].relatedMenu
        ? dynamnicTopMenu3[0].relatedMenu
        : null,
    };
    var TopMenuTransactionMobile = {
      title: dynamnicTopMenu3[0].title,
      menuHeadingId: dynamnicTopMenu3[0].menuHeadingId,
      menuPath: dynamnicTopMenu3[0].menuPath,
      menuId: dynamnicTopMenu3[0].mstMenuId,
      relatedMenu: dynamnicTopMenu3[0].relatedMenu
        ? dynamnicTopMenu3[0].relatedMenu
        : null,
      icon: (
        <svg viewBox="0 0 640 512" fill="currentColor" class="w-6 h-6">
          <path d="M535 41c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l64 64c4.5 4.5 7 10.6 7 17s-2.5 12.5-7 17l-64 64c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l23-23-174-.2c-13.3 0-24-10.7-24-24s10.7-24 24-24h174.1L535 41zM105 377l-23 23h174c13.3 0 24 10.7 24 24s-10.7 24-24 24H81.9l23 23c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L7 441c-4.5-4.5-7-10.6-7-17s2.5-12.5 7-17l64-64c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9zM96 64h241.9c-3.7 7.2-5.9 15.3-5.9 24 0 28.7 23.3 52 52 52h117.4c-4 17 .6 35.5 13.8 48.8 20.3 20.3 53.2 20.3 73.5 0l19.3-19.3V384c0 35.3-28.7 64-64 64H302.1c3.7-7.2 5.9-15.3 5.9-24 0-28.7-23.3-52-52-52H138.6c4-17-.6-35.5-13.8-48.8-20.3-20.3-53.2-20.3-73.5 0L32 342.5V128c0-35.3 28.7-64 64-64zm64 64H96v64c35.3 0 64-28.7 64-64zm384 192c-35.3 0-64 28.7-64 64h64v-64zm-224 32c53 0 96-43 96-96s-43-96-96-96-96 43-96 96 43 96 96 96z" />
        </svg>
      ),
    };
  }

  if (userCapabilityTopMenu.filter((item) => item.MstMenuHeadingId === 4)) {
    var dynamnicTopMenu4 = userCapabilityTopMenu
      .filter((item) => item.MstMenuHeadingId === 4)
      .map((item) => ({
        title: item.MenuHeading,
        menuHeadingId: item.MstMenuHeadingId,
        menuPath: item.MenuPath,
        mstMenuId: item.MstMenuId,
      }));
  } else {
    console.log("Reports permission denied");
  }

  if (dynamnicTopMenu4.length > 0) {
    var TopMenuReports = {
      title: dynamnicTopMenu4[0].title,
      menuHeadingId: dynamnicTopMenu4[0].menuHeadingId,
      menuPath: dynamnicTopMenu4[0].menuPath,
      menuId: dynamnicTopMenu4[0].mstMenuId,
    };
    var TopMenuReportsMobile = {
      title: dynamnicTopMenu4[0].title,
      menuHeadingId: dynamnicTopMenu4[0].menuHeadingId,
      menuPath: dynamnicTopMenu4[0].menuPath,
      menuId: dynamnicTopMenu4[0].mstMenuId,
      icon: (
        <svg
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          viewBox="0 0 24 24"
          class="w-6 h-6"
        >
          <path stroke="none" d="M0 0h24v24H0z" />
          <path d="M8 5H6a2 2 0 00-2 2v12a2 2 0 002 2h5.697M18 14v4h4M18 11V7a2 2 0 00-2-2h-2" />
          <path d="M10 3 H12 A2 2 0 0 1 14 5 V5 A2 2 0 0 1 12 7 H10 A2 2 0 0 1 8 5 V5 A2 2 0 0 1 10 3 z" />
          <path d="M22 18 A4 4 0 0 1 18 22 A4 4 0 0 1 14 18 A4 4 0 0 1 22 18 z" />
          <path d="M8 11h4M8 15h3" />
        </svg>
      ),
    };
  }
  const createDynamicMenus = (menuHeadingId) => {
    return userCapabilityTopMenu
      .filter((item) => item.MstMenuHeadingId === menuHeadingId)
      .map((item) => ({
        title: item.MenuHeading,
        menuHeadingId: item.MstMenuHeadingId,
        menuPath: item.MenuPath,
        menuId: item.MstMenuId,
        relatedMenu: item.RelatedMenu || null,
      }));
  };

  const dynamicMenus = {
    topMenu: createDynamicMenus(1),
    adminMenu: createDynamicMenus(2),
    transactionMenu: createDynamicMenus(3),
    reportsMenu: createDynamicMenus(4),
    reviewerMenu: createDynamicMenus(5),
  };

  const topMenuList = [
    ...dynamicMenus.topMenu,
    dynamicMenus.adminMenu[0],
    dynamicMenus.transactionMenu[0],
    dynamicMenus.reportsMenu[0],
    dynamicMenus.reviewerMenu[0],
  ].filter(Boolean);

  const topMenuMobileList = [
    ...dynamnicTopMenuMobile,
    TopMenuAdminMobile,
    TopMenuTransactionMobile,
    TopMenuReportsMobile,
  ];

  const filteredTopMenuListMobile = topMenuMobileList.filter(
    (menuItem) => menuItem !== undefined
  );
  // Check specifically for dashboard path
  const showDashboard = hasMenuPath("/dashboard");
  const navBarMenu = {
    menuWidth: `w-full lg:block px-4 py-2 sm:px-1 lg:px-8`,
    menuSpace: "flex items-center justify-between gap-3 h-fit",
    menuList: `ml-10 items-baseline hidden md:flex lg:flex md:ml-2`,
    logoPosition: "flex items-center w-48",
    menu: "text-[#FFFFFF] hover:text-gray-100 hover:bg-gray-700 px-3 py-2 flex flex-col justify-center rounded-md text-xs font-medium",
    menuActive: "bg-[#f2efe8] text-black",
    hiddenMenuSpace: "px-2 pt-2 pb-3 space-y-1 sm:px-3",
    menuButton:
      "bg-[#FFFFFF] inline-flex items-center sm:mx-3 md:hidden justify-center lg:p-2 md:p-1 rounded-md text-gray-400 hover:text-white hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-[#FFFFFF] focus:ring-white",
    menuButtonHidden:
      "hover:bg-gray-700 text-white block px-3 py-2 rounded-md text-base font-medium",
    profileImage: "w-12 h-12 rounded-full bg-white",
    profileImageText:
      "w-12 h-12  rounded-full bg-[#F0E1A5] flex justify-center py-1 align-center text-3xl font-medium text-red-600",
    profileImagePosition:
      "flex justify-end justify-evenly gap-2 items-center md:order-2",
    profileImageButton: "flex justify-center text-sm rounded-full",
  };
  const [topMenuVisiblity, setTopMenuVisibility] = useState(false);
  const [pageName, setPageName] = useState("");
  const [viewsAll, setViewsAll] = useState(false);
  const [notifications, setNotifications] = useState(false);
  const [userProfilePopUp, setUserProfilePopUp] = useState(false);
  const [passwordPopUp, setPasswordPopUp] = useState(false);
  const [systemSettingPopup, setSystemSettingPopup] = useState(false);
  const dropdownRef = useRef(null);

  const handlePopup = () => {
    setUserProfilePopUp(true);
  };
  const handlePassword = () => {
    setPasswordPopUp(true);
  };

  const LogOut = async () => {
    const createdBy = sessionStorage.getItem("createdBy");
    const data = {
      sessionId: 0,
      mstUserId: Number(createdBy),
      lastActivity: new Date().toISOString(),
      isActive: 0,
      flag: 1,
    };

    try {
      const response1 = await LoginAPI(data, "Login/Login");
      if (response1.success) {
        navigate("/");
        sessionStorage.clear();
        localStorage.clear();
      }
    } catch (error) {
      console.error("Logout API Error", error);
    }
  };
  const handleClose = () => {
    setUserProfilePopUp(false);
    setPasswordPopUp(false);
    setSystemSettingPopup(false);
    setNotifications(false);
  };
  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setViewsAll(false);
    }
  };

  useEffect(() => {
    if (viewsAll) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    // Cleanup on unmount
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [viewsAll]);

  const getUserFirstcharAt = (name) =>
    name ? name.charAt(0).toUpperCase() : "";

  const renderProfileImage = () => {
    if (userProfileImg) {
      return (
        <img
          className={navBarMenu.profileImage}
          src={userProfileImg}
          alt="user"
        />
      );
    } else if (firstName) {
      return (
        <div className={navBarMenu.profileImageText}>
          {getUserFirstcharAt(firstName)}
        </div>
      );
    }
  };
  // Function to handle menu click and set the currentMenuId

  return (
    <nav className="bg-[#FFFFFF] p-2">
      <div className={navBarMenu.menuSpace}>
        <div className="flex items-center">
          <div className="flex-shrink-0  px-1">
            <NavLink
              to="#"
              onClick={(e) => {
                e.preventDefault(); // prevent default link behavior
                LogOut(); // call your logout function
              }}
            >
              <img
                src={StayCool}
                className="h-16 sm:h-14"
                alt="customer Logo"
              />
            </NavLink>
          </div>



        </div>

        <div className=" flex justify-end items-center">
          <div
            ref={dropdownRef}
            class={navBarMenu.profileImagePosition}
            onClick={() => setViewsAll(!viewsAll)}
          >
            <button
              type="button"
              class={navBarMenu.profileImageButton}
              id="user-menu-button"
              aria-expanded="false"
              data-dropdown-toggle="user-dropdown"
              data-dropdown-placement="bottom"
            >
              <p
                className={
                  "text-[#3D6643] px-3 py-2 flex flex-col justify-center rounded-md text-xs font-medium"
                }
              >
                {userName ? userName : null}
                <span className="text-xs text-center">{OrganizationName}</span>
              </p>
              {renderProfileImage()}
            </button>
            {viewsAll && (
              <div
                id="dropdownDots"
                class="z-10 bg-white absolute top-14 right-5 divide-y divide-gray-100 rounded-lg shadow w-44 "
              >
                <ul
                  class="py-2 text-sm text-gray-700 "
                  aria-labelledby="dropdownMenuIconButton"
                >
                  <li>
                    <a
                      class="block px-4 py-2 cursor-pointer hover:bg-gray-100 "
                      onClick={handlePopup}
                    >
                      User Profile
                    </a>
                  </li>
                  <li>
                    <a
                      class="block px-4 py-2 cursor-pointer hover:bg-gray-100 "
                      onClick={handlePassword}
                    >
                      Change Password
                    </a>
                  </li>
                  <li>
                    <a
                      onClick={() => setShowLogoutModal(true)}
                      class="block px-4 py-2 cursor-pointer hover:bg-gray-100 "
                    >
                      Log Out
                    </a>
                  </li>
                </ul>
              </div>
            )}
          </div>
        </div>
      </div>

      {showLogoutModal && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-30"
          onClick={() => setShowLogoutModal(false)} // Close on backdrop click
        >
          <div
            className="bg-white rounded-lg p-8 shadow-xl w-[90%] max-w-xl" // Larger size
            onClick={(e) => e.stopPropagation()} // Prevent closing when clicking inside
          >
            <h2 className="text-2xl font-bold mb-4">Confirm Logout</h2>
            <p className="text-lg mb-6">Are you sure you want to log out?</p>
            <div className="flex justify-end gap-4">
              <button
                onClick={() => {
                  setShowLogoutModal(false);
                  LogOut();
                }}
                className="px-6 py-2 bg-gray-800 text-white rounded hover:bg-gray-900 text-lg"
              >
                Yes
              </button>
              <button
                onClick={() => setShowLogoutModal(false)}
                className="px-6 py-2 bg-gray-300 rounded hover:bg-gray-400 text-lg"
              >
                No
              </button>
            </div>
          </div>
        </div>
      )}

      <div className="md:hidden  lg:hidden  block" id="mobile-menu">

      </div>

      <MainPopup
        popUpOpen={userProfilePopUp}
        setpopUpOpen={setUserProfilePopUp}
      >
        <div>
          <button class="w-full">
            <span
              className="text-white flex justify-end"
              onClick={handleClose}
              class="text-2xl p-0 m-o block float-right mr-3"
            >
              &times;
            </span>
          </button>
          <UserProfile
            data={userProfileDatas}
            closePopup={() => setUserProfilePopUp(!userProfilePopUp)}
          />
        </div>
      </MainPopup>
      <MainPopup popUpOpen={passwordPopUp} setpopUpOpen={setPasswordPopUp}>
        <div>
          <button class="w-full">
            <span
              className="text-white flex justify-end"
              onClick={handleClose}
              class="text-2xl p-0 m-o block float-right mr-3"
            >
              &times;
            </span>
          </button>
          <PasswordPopup closePopup={handleClose} />
        </div>
      </MainPopup>
      <MainPopup
        popUpOpen={systemSettingPopup}
        setpopUpOpen={setSystemSettingPopup}
      >
        <div>
          <button class="w-full">
            <span
              className="text-white flex justify-end"
              onClick={handleClose}
              class="text-2xl p-0 m-o block float-right mr-3"
            >
              &times;
            </span>
          </button>
          <SystemSettingsPopup closePopup={handleClose} />
        </div>
      </MainPopup>
    </nav>
  );
}

export default TopMenu;
